import ACTIONS from '../actionTypes/auth'
import AuthService from '../../services/AuthService'

export const clearAuthData = () => { 
  return { type: ACTIONS.CLEAR_AUTH_DATA }
}

export const signinRedirectCallback = () => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_SIGN_REDIRECT_CALLBACK })

    return AuthService.instance?.signinRedirectCallback().then((res) => {
      if (res) {
        dispatch({ type: ACTIONS.SIGN_REDIRECT_CALLBACK_SUCCESS, payload: res })
        return res
      } else {
        dispatch({ type: ACTIONS.SIGN_REDIRECT_CALLBACK_FAILED })
        return null
      }
    }).catch((err) => { 
      dispatch({ type: ACTIONS.SIGN_REDIRECT_CALLBACK_FAILED })
      return null
    })
  }
}

export const signinSilentCallback = () => {
  return () => {
    return AuthService.instance?.signinSilentCallback().then((res) => {
      if (res) {
        return res
      }
    }).catch((err) => { 
      return null
    })
  }
}